module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page page-product"
  }, [_c('transition', {
    attrs: {
      "name": "slideRight"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canAnimate3),
      expression: "canAnimate3"
    }],
    staticClass: "footnote"
  }, [_vm._v("*Плейстейшн Про")])]), _vm._v(" "), _c('div', {
    staticClass: "video-wrapper"
  }), _vm._v(" "), _c('div', {
    staticClass: "page-overlay"
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slideDown"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canAnimate3),
      expression: "canAnimate3"
    }],
    staticClass: "lines-wrapper oh"
  }, [_c('div', {
    staticClass: "lines"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('div', {
    staticClass: "page-container"
  }, [_c('transition', {
    attrs: {
      "name": "slideLeft"
    }
  }, [_c('h1', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canAnimate3),
      expression: "canAnimate3"
    }],
    staticClass: "title"
  }, [_vm._v("УЖЕ В ПРОДАЖЕ")])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slideRight"
    }
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canAnimate3),
      expression: "canAnimate3"
    }],
    staticClass: "text"
  }, [_vm._v("\n\t\t\t\t\tFIFA 18 на базе Frostbite™ стирает границы между виртуальным и реальным миром, досконально воссоздавая игроков, команды и атмосферу настоящего футбола.\n\t\t\t\t")])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slideUp"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canAnimate3),
      expression: "canAnimate3"
    }],
    staticClass: "product"
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slideDown"
    }
  }, [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canAnimate3),
      expression: "canAnimate3"
    }],
    staticClass: "btn",
    attrs: {
      "href": "https://www.easports.com/ru/fifa/buy/russia?utm_campaign=fifa18_hd_ru_scm_fixd_dcm&utm_medium=display&utm_source=championat_buy_sp&utm_content=banner&utm_term=c3",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.Helpers.ga().send('click', 'Купить Fifa');
      }
    }
  }, [_vm._v("\n\t\t\t\t\tКУПИТЬ\n\t\t\t\t")])])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-480d9b5e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Product.vue
// module id = 501
// module chunks = 1